<div
  class="cat-phrase-ref-container"
  (mouseenter)="displayEditBtn = !editMode"
  (mouseleave)="displayEditBtn = false"
>
  <div class="ref-with-view" *ngIf="!editMode">
    <div *ngIf="pointerWord" class="pointer-container">
      <div class="ref-pointer">
        <formatted-phrase [phraseWords]="[pointerWord]"></formatted-phrase>
        &nbsp;
        <button
          *ngIf="editable"
          class="t-small t-button t-button--pill t-btn-more bg-white"
          (click)="displayPointerWordList = !displayPointerWordList"
        >
          <i class="fas fa-angle-down t-small"></i>
        </button>
      </div>

      <slide-in-out [isOpen]="displayPointerWordList">
        <div class="l-flex l-wrap t-row--med">
          <div *ngFor="let word of mainPhraseWords">
            <checkbox-wrap class="checkbox" [label]="word.text">
              <input
                type="radio"
                [value]="word"
                [disabled]="disabled"
                [name]="ref.refPhraseId"
                [(ngModel)]="pointerWord"
                (ngModelChange)="onWordChanged()"
              />
            </checkbox-wrap>
            &nbsp;&nbsp;
          </div>
        </div>
      </slide-in-out>
    </div>

    <p *ngIf="ref.phraseDispWords.length == 0 && ref.refPhraseText" class="text">
      {{ ref.refPhraseText }}
    </p>
    <formatted-phrase
      *ngIf="ref.phraseDispWords.length > 0"
      class="text"
      [phraseWords]="ref.phraseDispWords"
    ></formatted-phrase>
    <p *ngIf="ref.phraseDispWords.length == 0 && !ref.refPhraseText && ref.anchors != null && ref.anchors.length > 0">
      {{ ref.anchors[0]?.embeddedObjectAnnotation?.docName }}
    </p>
    <!-- Add HERE COPY ALL BUTTON WITH CONDITION -->
    <div class="ref-view-action" *ngIf="refDoc != null" style="align-items: center;">
      <div *ngIf="!editAnchors && matchedRef && ref.anchors != null && ref.anchors.length > 0" style="margin-right: 5px;">
              <copy-all-anchors [catMatchRefAnchors]="ref.anchors"
              [copyAnchors]="true"
              [disableConsistencyCheckResultsActions]="disableConsistencyCheckResultsActions"
              [phrase]="mainPhrase"
              [workingRefAnchors]="matchedRef.anchors"

              >

              </copy-all-anchors>
        </div>
        <i
          style="cursor: pointer; color: #0978a2"
          class="icon fa-solid fa-arrow-up-right-from-square"
          [class.selected]="true"
          [tooltip]="'translate.general.viewRefDoc' | translate"
          (click)="showRefDoc = true;">
        </i>
    </div>
  </div>

  <div *ngIf="showMatchSimilarityCode &&ref.matchSimilarityCode" class="ref-similarity">
    <p *ngIf="ref.matchSimilarityCode != 'MISSING'">
      {{ ref.similarityPct | percent }}
      {{ "translate.general.similarity" | translate }}
    </p>
    <p *ngIf="ref.matchSimilarityCode == 'MISSING'" class="missing">
      {{ "translate.rev.missing" | translate }}
    </p>
  </div>

  <div *ngIf="ref.altCatRefPhraseId > 0" class="ref-similarity">
    <p class="missing">
      {{ "translate.rev.altRefUsed" | translate }}
    </p>
  </div>

  <p *ngIf="ref.extraRefSw" class="extra">Extra context in working phrase</p>

  <textarea
    *ngIf="editMode"
    class="edit-area"
    pTextarea
    [(ngModel)]="ref.refPhraseText"
    autoResize="true"
    (ngModelChange)="markChanges()"
  ></textarea>
  <ng-container *ngIf="ref.anchors != null && ref.anchors.length > 0">
    <div>
<!--       <div class="t-small" style="margin-top: 10px; margin-bottom: 10px">
          <a (click)="toggleDisplayAnchors()" 
          >
              <span [ngClass]="!ref.showAnchors ? 'pi pi-angle-down' : 'pi pi-angle-up'" style="margin-left: 0.3em;"></span>  
          </a>        
      </div> -->

        <mng-anchors style="margin-top: 10px" *ngIf="ref.showAnchors" [anchors]="ref.anchors"
        (viewPageAndRef)="viewPageAndRef($event)"
        (showRefDoc)="showRefDoc = true"
        [phrase]="mainPhrase"
        [disableActions]="disableConsistencyCheckResultsActions"
        [displayActions]="displayActionsForUpdatingAnchors"
        [copyAnchors]="!displayActionsForUpdatingAnchors && matchedRef"
        [workingRefAnchors]="matchedRef?.anchors"
        >

        </mng-anchors>
      </div>
    </ng-container>
    <ng-container *ngIf="showAddAnchors">
      <a *ngIf="!isAddAnchorsDisabled() && ref.refType != 'FOOTNOTE'" [class.disabled]="disableConsistencyCheckResultsActions" (click)="toggleAddContextDropdown()" class="add-context-btn" style="margin-left: 0.5rem; cursor: pointer;">
                <i [class.disabled]="disableConsistencyCheckResultsActions" [ngClass]="showAddContextDropdown.value ? 'fas fa-minus' : 'fas fa-plus'"></i>  {{ "translate.general.addAnchor" | translate }}
      </a>
        <ng-container *ngIf="mainPhrase && showAddContextDropdown && showAddContextDropdown.value">
          <add-anchor [phrase]="mainPhrase" [curDoc]="curCatDoc" [reference]="ref"
          [layoutClass]="'reference'"
          [disabled]="disableConsistencyCheckResultsActions"
          [showAddContextDropdown]="showAddContextDropdown">

          </add-anchor>
          <div></div>
        </ng-container>
      </ng-container>
      <!-- SHOW PLACEHOLDER ADDED_REFERENCE, ADDED_ANCHOR_REFERENCE -->
      <ng-container *ngIf="showReferenceIssueType">
        <div *ngIf="(referenceIssue && referenceIssue.refFinding === 'ADDED_REFERENCE') || (addedConsistencyGeneratedReference)" class="ref-similarity-code">
          <p class="extra" [class.anchor-missing]="addedConsistencyGeneratedReference">
            {{ "translate.rev.refAdded" | translate }}
          </p>
        </div>
        <div class="ref-similarity-code" *ngIf="referenceIssue && referenceIssue.refFinding === 'ADDED_ANCHOR_REFERENCE'">
          <p class="missing-reference-anchor">
            {{ "translate.rev.refMissingAnchorReference" | translate }}
          </p>
        </div>
      </ng-container>
  <div class="l-align-spaceBetween l-mar-top">
    <div *ngIf="ref.refPhraseId && !ref.isConsistencyGenerated">
      <span class="footnote id"
        >{{ "translate.cat.phraseId" | translate }}: {{ ref.refPhraseId }}</span
      >
    </div>
    <div class="icons" *ngIf="editable">
      <!--edit-->
      <i
        *ngIf="allowEdit && showEdit"
        (click)="editMode = true"
        class="fas fa-edit icon-edit"
      ></i>

      <!--cancel edit-->
      <i
        *ngIf="editMode && ref.refPhraseId && showEdit"
        (click)="discardChanges()"
        class="fas fa-undo icon-edit"
      ></i>

      <!--delete-->
<!--       <a *ngIf="showDelete" (click)="onDeleteClicked()" class="t-small">Remove</a> -->
    </div>
  </div>
</div>


<modal-popup
  *ngIf="showRefDoc && refDoc != null"
  [flexible]="false"
  [hideHeader]="false"
  [title]="refDoc.docName"
  [isOpen]="showRefDoc && refDoc != null"
  (onClose)="showRefDoc = false"
>
  <div class="pdf-container">
    <pdf-viewer
      #docViewer
      [doc]="refDoc"
      [initialPage]="1"
      [displayDrawMode]="false"
      [displayToggleBoundingBoxes]="false"
      [singlePage]="false"
    ></pdf-viewer>
  </div>
</modal-popup>
